import DeleteIcon from "@mui/icons-material/Delete";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  IconButton,
  MenuItem,
  Stack,
  Switch,
  Select,
  TableSortLabel,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  CircularProgress,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { alpha } from "@mui/material/styles";
import { visuallyHidden } from "@mui/utils";
import { format } from "date-fns";
import PropTypes from "prop-types";
import * as React from "react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ItemButton from './Dialogs/ItemButton.js';
import {
  retrieveAllCostsApi,
  retrieveCostByIdApi,
} from "../../../components/api/CostApiService";
import {
  retrieveAllItemsApi,
  retrieveItemByIdApi,
} from "../../../components/api/ItemApiService";
import { acquireLockApi } from "../../../components/api/LockApiService";
import {
  approveOfferApi,
  createOfferApi,
  deleteOffersApi,
  retrieveAllOffersApi,
  retrieveFastFilteredOffersApi,
  retrieveFastOffersApi,
  retrieveFilteredOffersApi,
  retrieveMaxOfferNumberApi,
  retrieveOfferByIdApi,
  retrieveSelectedOffersByIdApi,
  updateOfferApi,
} from "../../../components/api/OfferApiService";
import {
  retrieveAllSamplesApi,
  retrieveSampleByIdApi,
} from "../../../components/api/SampleApiService";
import { retrieveFastStakeholdersApi } from "../../../components/api/StakeholderApiService";
import ExportExcel from "../../../utils/excelExport";
import EditCost from "../CostView/EditCost";
import EditItem from "../ItemView/EditItem";
import EditSample from "../SampleView/EditSample";
import EditVendorOffer from "../VendorOfferView/EditVendorOffer.js";
import AddCustomerOffer from "./AddCustomerOffer";
import CustomerOfferSearch from "./CustomerOfferSearch";
import CreateOfferPdf from "./Dialogs/CreateOfferPdf";
import CreateOrder from "./Dialogs/CreateOrder";
import CreateVendorOffer from "./Dialogs/CreateVendorOffer";
import EditCustomerOffer from "./EditCustomerOffer";
import AddSingleCustomerOffer from "./Dialogs/AddSingleCustomerOffer";
import { useLocation } from "react-router";
import CostButton from "./Dialogs/CostButton.js";
import SampleButton from "./Dialogs/SampleButton.js";
import ApproveOfferButton from "./Dialogs/ApproveOfferButton.js";
import { retrieveUsersApi } from "../../../components/api/UserApiService.js";
import AddSample from "../SampleView/AddSample.js";
import ReservationDialog from "../VendorOfferView/Dialogs/ReservationDialog.js";
import { createReservationApi } from "../../../components/api/ReservationApiService.js";
import OfferButton from "./Dialogs/OfferButton.js";
import ApprovedEditButton from "./Dialogs/ApproveEditButton.js";
import { useAuth } from "../../../auth/AuthContext.js";

const MAX_BULK_SELECTION = 20;

const headCells = [
  {
    id: "editButton",
    disablePadding: true,
    label: "",
    width: 45,
  },
  {
    id: "id",
    numeric: true,
    disablePadding: true,
    label: "ID",
  },
  {
    id: "offerGroupNumber",
    numeric: true,
    disablePadding: true,
    label: "Offer Number",
  },
  {
    id: "assignedUser",
    disablePadding: true,
    label: "Assigned To",
  },
  {
    id: "customer",
    numeric: true,
    disablePadding: true,
    label: "Customer Code",
  },
  {
    id: "customerName",
    numeric: false,
    disablePadding: true,
    label: "Customer Name",
  },
  {
    id: "itemId",
    numeric: true,
    disablePadding: true,
    label: "Item ID",
  },
  {
    id: "itemTobaccoCode",
    numeric: true,
    disablePadding: true,
    label: "Tobacco Code",
    width: 150,
  },
  {
    id: "itemBuyingGrade",
    numeric: false,
    disablePadding: true,
    label: "Buying Grade",
  },
  {
    id: "itemSalesGrade",
    numeric: false,
    disablePadding: true,
    label: "Sales Grade",
  },
  {
    id: "itemCrop",
    numeric: false,
    disablePadding: true,
    label: "Crop",
  },
  {
    id: "salesCrop",
    numeric: false,
    disablePadding: true,
    label: "Sales Crop",
  },
  {
    id: "itemNicotine",
    numeric: true,
    disablePadding: true,
    label: "Nicotine",
  },
  {
    id: "salesNicotine",
    numeric: true,
    disablePadding: true,
    label: "Sales Nicotine",
  },
  {
    id: "itemSugar",
    numeric: true,
    disablePadding: true,
    label: "Sugar",
  },
  {
    id: "salesSugar",
    numeric: true,
    disablePadding: true,
    label: "Sales Sugar",
  },
  {
    id: "itemMoisture",
    numeric: true,
    disablePadding: true,
    label: "Moisture",
  },
  {
    id: "itemOrigin",
    numeric: false,
    disablePadding: true,
    label: "Origin",
  },
  {
    id: "salesOrigin",
    numeric: false,
    disablePadding: true,
    label: "Sales Origin",
  },
  {
    id: "itemType",
    numeric: false,
    disablePadding: true,
    label: "Type",
  },
  {
    id: "itemStorage",
    numeric: false,
    disablePadding: true,
    label: "Current Location",
  },
  {
    id: "company",
    numeric: false,
    disablePadding: true,
    label: "Company",
    width: 150,
  },
  {
    id: "approvalStatus",
    numeric: false,
    disablePadding: true,
    label: "SG Approval Status",
    width: 150,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Status",
    width: 85,
  },
  {
    id: "statusDeadline",
    numeric: false,
    disablePadding: true,
    label: "Status Deadline",
  },
  {
    id: "costId",
    numeric: true,
    disablePadding: true,
    label: "Cost Id",
  },
  {
    id: "estimatedTotalCost",
    numeric: true,
    disablePadding: true,
    label: "Estimated Total Cost",
  },
  {
    id: "buyingPrice",
    numeric: true,
    disablePadding: true,
    label: "Buying Price Per Kg",
  },
  {
    id: "firstOfferPrice",
    numeric: true,
    disablePadding: true,
    label: "First Offer",
  },
  {
    id: "firstOfferPriceUsd",
    numeric: true,
    disablePadding: true,
    label: "First Offer (USD)",
  },
  {
    id: "finalOfferPrice",
    numeric: true,
    disablePadding: true,
    label: "Final Offer",
  },
  {
    id: "finalOfferPriceUsd",
    numeric: true,
    disablePadding: false,
    label: "Final Offer (USD)",
  },
  {
    id: "offerSampleId",
    numeric: true,
    disablePadding: true,
    label: "Offer Sample",
  },
  {
    id: "offerSampleDate",
    numeric: true,
    disablePadding: true,
    label: "Offer Sample Date",
  },
  {
    id: "offerSampleStatus",
    numeric: false,
    disablePadding: true,
    label: "Offer Sample Status",
  },
  {
    id: "trialSampleId",
    numeric: true,
    disablePadding: true,
    label: "Trial Sample",
  },
  {
    id: "trialSampleDate",
    numeric: true,
    disablePadding: true,
    label: "Trial Sample Date",
  },
  {
    id: "trialSampleStatus",
    numeric: false,
    disablePadding: true,
    label: "Trial Sample Status",
  },
  {
    id: "packaging",
    numeric: false,
    disablePadding: false,
    label: "Packaging",
    width: 85,
  },
  {
    id: "paymentTerm",
    numeric: false,
    disablePadding: true,
    label: "Payment Term",
    width: 150,
  },
  {
    id: "incoterm",
    numeric: true,
    disablePadding: true,
    label: "Incoterm",
  },
  {
    id: "numberOfCase",
    numeric: true,
    disablePadding: true,
    label: "Number Of Cartons",
  },
  {
    id: "netWeightPerCase",
    numeric: true,
    disablePadding: true,
    label: "Net Weight Per Carton",
  },
  {
    id: "volume",
    numeric: true,
    disablePadding: true,
    label: "Volume",
  },
  {
    id: "totalAmount",
    numeric: true,
    disablePadding: true,
    label: "Total Amount",
  },
  {
    id: "usdTotalAmount",
    numeric: true,
    disablePadding: true,
    label: "Total Amount USD",
  },
  {
    id: "offerDate",
    numeric: false,
    disablePadding: true,
    label: "Offer Date",
  },
  {
    id: "validityDate",
    numeric: false,
    disablePadding: true,
    label: "Validity Date",
  },
  {
    id: "portOfDischarge",
    numeric: false,
    disablePadding: true,
    label: "Port Of Discharge",
    width: 200,
  },
  {
    id: "portOfLoading",
    numeric: false,
    disablePadding: true,
    label: "Port Of Loading",
    width: 200,
  },
  {
    id: "remark",
    numeric: false,
    disablePadding: true,
    label: "Remark",
    width: 200,
  },
  {
    id: "comment",
    numeric: false,
    disablePadding: true,
    label: "Comment",
    width: 200,
  },
  {
    id: "offerLink",
    numeric: false,
    disablePadding: true,
    label: "Offer Link",
  },
  {
    id: "documentStatus",
    numeric: false,
    disablePadding: true,
    label: "Document Status",
  },
  {
    id: "creationTime",
    numeric: false,
    disablePadding: true,
    label: "Creation Time",
  },
  {
    id: "createdBy",
    numeric: false,
    disablePadding: true,
    label: "Created By",
  },
  {
    id: "recordStatus",
    numeric: false,
    disablePadding: true,
    label: "Record Status",
  },
  {
    id: "referenceOffer",
    numeric: false,
    disablePadding: true,
    label: "Reference Vendor Offer",
  },

  /*{
    id: "vendorOrderButton",
    disablePadding: true,
    label: "",
  },*/
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "asc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]) || [];
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    showButtons,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={
              headCell.id === "editButton"
                ? {
                  position: "sticky",
                  left: 0,
                  zIndex: 3,
                }
                : headCell.id === "id"
                  ? {
                    position: 'sticky',
                    left: showButtons ? 60 + 650 : 60,
                    zIndex: 3,
                  }
                  : headCell.id === "offerGroupNumber"
                    ? {
                      position: 'sticky',
                      left: showButtons ? 125 + 650 : 125,
                      zIndex: 3,
                    }
                    : headCell.id === "customerName"
                      ? {
                        position: "sticky",
                        left: showButtons ? 268 + 650 : 268,
                        zIndex: 3,
                      }
                      : headCell.id === "itemBuyingGrade"
                        ? {
                          position: 'sticky',
                          left: showButtons ? 439 + 650 : 439,
                          zIndex: 3,
                        }
                        : null
            }
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const {
    numSelected,
    setShowFilters,
    showFilters,
    rows,
    setAddView,
    selected,
    setPdfPopup,
    selectedData,
    onOpenBulkAssignDialog,
    onOpenBulkApproveDialog,
  } = props;
  const [deletePopup, setDeletePopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false); 

  const handleExportOffers = async () => {
    const notApprovedOffers = selectedData.filter(offer => offer?.approvalStatus !== 'Approved');
    if (notApprovedOffers.length > 0) {
      const notApprovedIds = notApprovedOffers.map(offer => offer?.id);
      toast.error(`Cannot export offers with IDs: ${notApprovedIds.join(', ')} as they are not approved.`, { autoClose: 5000 });
    } else {
      try {
        setIsLoading(true);
        const response = await retrieveSelectedOffersByIdApi(selected, "CUSTOMER");
        if (response?.data) {
          setPdfPopup({
            data: response.data,
            visible: true,
          });
          toast.success("Customer offers retrieved successfully.");
        }
      } catch (error) {
        console.log(error.response?.data);
        toast.error("Customer offers could not be retrieved.");
      }finally {
        setIsLoading(false); 
      }
    }
  };

  const handleDelete = async () => {
    try {
      const response = await deleteOffersApi(selected);
      console.log(response?.data);
      toast.success("Customer offer(s) deleted successfully.");
      window.location.reload();
    } catch (error) {
      console.log(error.response?.data);
      toast.error("Customer offer(s) could not be deleted.");
    }
  };

  function createNewExportObject(rows) {
    const newObjects = [];
    const headerMapping = {
      ID: "id",
      "Offer Number": (row) =>
        `${row?.offerYear || ""}${row?.offerYear && row?.offerGroupNumber ? "-" : ""
        }${row?.offerGroupNumber || ""}`,
      "Item ID": "itemId",
      "Tobacco Code": "itemTobaccoCode",
      "Buying Grade": "itemBuyingGrade",
      "Sales Grade": "salesGrade",
      Crop: "itemCrop",
      Nicotine: "itemNicotine",
      Sugar: "itemSugar",
      Origin: "itemOrigin",
      Type: "itemType",
      "Current Location": "itemStorage",
      Company: "company",
      "Approval Status": "approvalStatus",
      Status: "status",
      "Status Deadline": (row) =>
        row?.statusDeadline
          ? format(new Date(row.statusDeadline), "dd/MM/yyyy")
          : "",
      "SAP Customer Code": "stakeholderCode",
      "Customer Name": "stakeholderName",
      "Estimated Cost ID": "estimatedCostId",
      "Estimated Total Cost": "estimatedTotalCost",
      "Buying Price": "buyingPrice",
      "Buying Price Currency": "buyingPriceCurrency",
      "First Offer Price": "firstOfferPrice",
      "First Offer Price Currency": "firstOfferPriceCurrency",
      "USD First Offer Price": "usdFirstOfferPrice",
      "Final Price": "finalOfferPrice",
      "Final Price Currency": "finalOfferPriceCurrency",
      "USD Final Offer Price": "usdFinalOfferPrice",
      "Offer Sample ID": "firstSampleId",
      "Offer Sample Delivery Date": (row) =>
        row?.firstSampleDeliveryDate
          ? format(new Date(row.firstSampleDeliveryDate), "dd/MM/yyyy")
          : "",
      "Offer Sample Status": "firstSampleStatus",
      "Trial Sample ID": "secondSampleId",
      "Trial Sample Delivery Date": (row) =>
        row?.secondSampleDeliveryDate
          ? format(new Date(row.secondSampleDeliveryDate), "dd/MM/yyyy")
          : "",
      "Trial Sample Status": "secondSampleStatus",
      Packaging: "packaging",
      "Payment Term": "paymentTerm",
      Incoterm: "incoterm",
      "Number of Cartons": "numberOfCases",
      "Net Weight Per Carton": "netWeightPerCase",
      Volume: "volume",
      "Volume Unit": "volumeUnit",
      "Total Amount": "totalAmount",
      "Total Amount Currency": "totalAmountCurrency",
      "Offer Date": (row) =>
        row?.offerDate ? format(new Date(row.offerDate), "dd/MM/yyyy") : "",
      "Validity Date": (row) =>
        row?.validityDate
          ? format(new Date(row.validityDate), "dd/MM/yyyy")
          : "",
      "Port of Loading": "portOfLoading",
      Remark: "remark",
      Comment: "comment",
      "Offer Link": "offerLink",
      "Document Status": "documentStatus",
      "Record Status": "recordStatus",
      "Editing Permission": "editingPermission",
      "Reference Offer ID": "referenceSanOfferId",
    };

    rows.forEach((row) => {
      const newObject = {};
      Object.entries(headerMapping).forEach(([header, pathOrFunction]) => {
        let value;
        if (typeof pathOrFunction === "function") {
          // Execute function for special processing
          value = pathOrFunction(row);
        } else {
          // Direct mapping or nested properties
          const keys = pathOrFunction.split("?.");
          value = row;
          for (const key of keys) {
            if (value == null) break;
            value = value[key];
          }
        }
        newObject[header] = value ?? ""; // Use nullish coalescing operator to default to empty string
      });
      newObjects.push(newObject);
    });

    return newObjects;
  }

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity,
            ),
        }),
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Dialog
        open={deletePopup}
        onClose={() => setDeletePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete {selected.length} offer(s)?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDelete}
            autoFocus
          >
            Yes
          </Button>
          <Button onClick={() => setDeletePopup(false)}>No</Button>
        </DialogActions>
      </Dialog>

      <Stack direction="row" spacing={1} alignItems={"center"}>
        <Typography
          sx={{ fontWeight: 600, fontSize: "20px" }}
          variant="h6"
          id="tableTitle"
          component="div"
          color="#1E2685"
        >
          Customer Offers
        </Typography>
        <Typography></Typography>
        {numSelected > 0 ? (
          <Typography
            sx={{ fontWeight: 200, fontSize: "16px" }}
            color="#1E2685"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography></Typography>
        )}

        {numSelected > 0 && (
          <Tooltip title="Delete">
            <IconButton onClick={() => setDeletePopup(true)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
        {numSelected > 0 && (
          <Button
            variant="outlined"
            onClick={onOpenBulkAssignDialog}
            disabled={numSelected > MAX_BULK_SELECTION}
          >
            Assign Selected
          </Button>
        )}
        {numSelected > 0 && (
          <Button
            variant="outlined"
            onClick={onOpenBulkApproveDialog}
            disabled={numSelected > MAX_BULK_SELECTION}
          >
            Approve Selected
          </Button>
        )}
        {numSelected > 0 && (
          <Button
            variant="outlined"
            sx={{ minWidth: "130px" }}
            style={{ whiteSpace: "nowrap", marginLeft: 20 }}
            disabled={isLoading}
            onClick={handleExportOffers}
          >
            {isLoading ? (
               <CircularProgress size={24} /> 
             ) : (
               "Create Offer Excel"
             )}
          </Button>
        )}
      </Stack>

      <Stack direction={"row"} spacing={1} sx={{ mr: 2 }}>
        <ExportExcel
          excelData={createNewExportObject(selectedData)}
          fileName={"ExcelExport"}
          buttonLabel="Export Table"
        />

        <Button
          disableElevation
          variant="outlined"
          size="small"
          onClick={() => setAddView(true)}
        >
          Add
        </Button>
        <Button
          variant="outlined"
          onClick={() => setShowFilters(!showFilters)}
          sx={{ minWidth: "130px" }}
          size="small"
        >
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </Stack>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onOpenBulkAssignDialog: PropTypes.func.isRequired,
  onOpenBulkApproveDialog: PropTypes.func.isRequired,
};

export default function CustomerOfferView() {
  const location = useLocation();
  const { user, userLoading } = useAuth();
  const storedUserId = user?.id;
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [items, setItems] = useState([]);
  const [offers, setOffers] = useState([]);
  const [vendorOffers, setVendorOffers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [samples, setSamples] = useState([]);
  const [costs, setCosts] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
    const [offerData, setOfferData] = useState([]);
  var filterCurr = new Date();
  filterCurr.setFullYear(filterCurr.getFullYear() - 100);
  var filterDate = filterCurr.toISOString().substring(0, 10);
  const [filterCustomerOffer, setFilterCustomerOffer] = useState({
    id: 0,
    offerType: "CUSTOMER",
    stakeHolderType: "CUSTOMER",
    itemBuyingGrade: "",
    itemIdList: [],
    companyList: [],
    approvalStatusList: [],
    statusList: [],
    vendorList: [],
    stakeholderIdList: [],
    firstSampleIdList: [],
    secondSampleIdList: [],
    costIdList: [],
    firstSampleDate: filterDate,
    secondSampleDate: filterDate,
    firstSampleStatusList: [],
    secondSampleStatusList: [],
    paymentTerm: "",
    paymentTermList: [],
    salesOrigin: "",
    salesOriginList: [],
    incotermList: [],
    volumeUnitList: [],
    firstPriceCurrencyList: [],
    finalPriceCurrencyList: [],
    remark: "",
    comment: "",
    portOfLoading: "",
    portOfLoadingList: [],
    portOfDischargeList: [],
    documentStatusList: [],
    tobaccoCode: "",
    salesGrade: "",
    buyingGrade: "",
    customerGrade: "",
    internalGrade: "",
    originList: [],
    typeList: [],
    leafFormList: [],
    colorList: [],
    storageList: [],
    itemStorage: "",
    referenceVendorOfferIdList: [],
    recordStatusList: ["ACTIVE"],
    idList: [],
  });
  const [addView, setAddView] = useState(false);
  const [addViewStates, setAddViewStates] = useState(null);
  const [rows, setRows] = useState([]);
  const [dense, setDense] = useState(true);
  const [showFilters, setShowFilters] = useState(false);
  const [maxOfferGroupNumber, setMaxOfferGroupNumber] = useState();
  const [item, setItem] = useState([]);
  const [cost, setCost] = useState([]);
  const [sample, setSample] = useState([]);
  const [showButtons, setShowButtons] = useState(false);

  const [users, setUsers] = useState([]);
  const [isAssignUserDialogOpen, setIsAssignUserDialogOpen] = useState(false);
  const [isDeclineDialogOpen, setIsDeclineDialogOpen] = useState(false);
  const [isBulkAssignDialogOpen, setIsBulkAssignDialogOpen] = useState(false);
  const [isBulkApproveDialogOpen, setIsBulkApproveDialogOpen] = useState(false);
  const [bulkSelectedUser, setBulkSelectedUser] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  let declineNote = null;
  const totalVolume = rows.reduce((sum, row) => sum + (row.volume || 0), 0);
  const usdTotalAmount = rows.reduce((sum, row) => sum + (row.usdTotalAmount || 0), 0);
  const [addSample, setAddSample] = useState(null);

  const [lock, setLock] = useState({
    userId: storedUserId,
    recordType: "EDITCUSTOMEROFFER",
  });
  const [showOrderPopup, setShowOrderPopup] = useState({
    visible: false,
    data: null,
  });

  const [reservationDialog, setReservationDialog] = useState({ open: false, offer: null });
  const todayStr = format(new Date(), "yyyy-MM-dd");
  const [reservationData, setReservationData] = useState({
    company: "",
    reservationDate: todayStr,
    validityDate: todayStr,
    numberOfCases: "",
    netWeightPerCase: "",
    quantity: "",
    volumeUnit: "KG",
    remark: "",
  });

  const [pdfPopup, setPdfPopup] = useState({
    visible: false,
    data: null,
  });
  const [showOfferPopup, setShowOfferPopup] = useState({
    visible: false,
    data: null,
  });
  const [addOfferToGroup, setAddOfferToGroup] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editCustomerOffer, setEditCustomerOffer] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editItem, setEditItem] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editCost, setEditCost] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editSample, setEditSample] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editVendorOffer, setEditVendorOffer] = useState({
    visible: false,
    data: null,
    index: null,
  });

  function mapOffer(offer) {
    return {
      ...offer, 
          assignedUserId: offer?.assignedUser?.id,
          assignedUserName: offer?.assignedUser?.name,
          assignedUserEmail: offer?.assignedUser?.email,
          stakeholderId: offer?.stakeholder?.id,
          stakeholderCode: offer?.stakeholder?.code,
          stakeholderName: offer?.stakeholder?.name,
          firstSampleId: offer?.firstSample?.id,
          firstSampleDeliveryDate: offer?.firstSample?.deliveryDate,
          seconsSampleId: offer?.secondSample?.id,
          secondSampleDeliveryDate: offer?.secondSample?.deliveryDate,
          itemId: offer?.item?.id,
          itemTobaccoCode: offer?.item?.tobaccoCode,
          itemBuyingGrade: offer?.item?.buyingGrade,
          itemInternalGrade: offer?.item?.internalGrade,
          itemOrigin: offer?.item?.origin,
          itemType: offer?.item?.type,
          itemLeafForm: offer?.item?.leafForm,
          itemCrop: offer?.item?.crop,
          itemStorage: offer?.item?.storage,
          itemNicotine: offer?.item?.nicotine,
          itemSugar: offer?.item?.sugar,
          itemMoisture: offer?.item?.moisture,
          estimatedCostId: offer?.estimatedCost?.id,
          estimatedTotalCost: offer?.estimatedCost?.totalCost,
    };
  }

  useEffect(() => {
    if (!location.state) {
      retrieveCustomerOffers();
      getMaxOfferNumber();
      retrieveUsers();
      console.log("No state found, retrieving all offers.");
    } else {
      setAddView(true);
      console.log("State found, retrieving filtered offers.");
    }
  }, []); 

  function retrieveUsers() {
    retrieveUsersApi()
      .then((response) => {
        setUsers(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const openDeclineDialog = (row) => {
    setSelectedRow(row);
    setIsDeclineDialogOpen(true);
  };
  const closeDeclineDialog = () => {
    setIsDeclineDialogOpen(false);
    setSelectedRow(null);
  };

  const openAssignUserDialog = (row) => {
    setSelectedRow(row);
    setIsAssignUserDialogOpen(true);
  };
  const closeAssignUserDialog = () => {
    setIsAssignUserDialogOpen(false);
    setSelectedRow(null);
    setSelectedUser("");
  };

  const handleAssignment = () => {
    if (selectedRow && selectedUser) {
      const assignmentDate = new Date();
      retrieveOfferByIdApi(selectedRow.id)
        .then((detailsResponse) => {
          const baseRow = detailsResponse?.data || selectedRow;
          const updatedRow = {
            ...baseRow,
            assignedUser: selectedUser,
            assignedUserId: selectedUser?.id,
            assignedUserName: selectedUser?.name,
            assignedUserEmail: selectedUser?.email,
            assignor: user?.email,
            assignmentDate,
            operation: "ASSIGNMENT",
          };
          return updateOfferApi(updatedRow.id, updatedRow).then(() => updatedRow);
        })
        .then((updatedRow) => {
          toast.success(
            `Customer offer assigned to ${updatedRow.assignedUser.name} successfully.`,
            { autoClose: 4000 },
          );
          if (rows && setRows) {
            const idx = rows.findIndex(row => row.id === updatedRow.id);
          
            if (idx !== -1) {
              const newRows = [...rows];
              newRows[idx] = { ...newRows[idx],  
                assignedUser: selectedUser,
                assignedUserId: selectedUser?.id,
                assignedUserName: selectedUser?.name, 
                assignedUserEmail: selectedUser?.email, 
                assignor: user?.email,
                assignmentDate,
                operation: "ASSIGNMENT"};
              setRows(newRows); 
            }
          }
          setSelectedData((prevSelectedData) =>
            prevSelectedData.map((row) =>
              row.id === updatedRow.id
                ? {
                    ...row,
                    assignedUser: selectedUser,
                    assignedUserId: selectedUser?.id,
                    assignedUserName: selectedUser?.name,
                    assignedUserEmail: selectedUser?.email,
                    assignor: user?.email,
                    assignmentDate,
                    operation: "ASSIGNMENT",
                  }
                : row,
            ),
          );
          closeAssignUserDialog();
        })
        .catch((error) => {
          toast.error("Something went wrong.");
          console.log(error.response.data);
        });
    }
  };

  const handleDecline = () => {
    if (selectedRow) {
      const note = declineNote || "";
      const updatedRow = {
        ...selectedRow,
        declineNote: declineNote,
        approvalStatus: "Declined",
        operation: "DECLINE",
      };
      updateOfferApi(updatedRow.id, updatedRow)
        .then((response) => {
          toast.success(`Customer offer declined successfully.`, {
            autoClose: 4000,
          });
          if (rows && setRows) {
            const idx = rows.findIndex(row => row.id === updatedRow.id);
          
            if (idx !== -1) {
              const newRows = [...rows];
              newRows[idx] = { ...newRows[idx],  
                declineNote: declineNote,
                approvalStatus: "Declined",
                operation: "DECLINE" }; 
              setRows(newRows); 
            }
          }
        })
        .catch((error) => {
          toast.error("Something went wrong.");
          console.log(error.response.data);
        });
      closeDeclineDialog();
    }
  };

  function acquireLock(lock) {
    return new Promise((resolve, reject) => {
      acquireLockApi(lock)
        .then((response) => {
          const isLocked = response?.data;
          resolve(isLocked); // Resolve the Promise with the isLocked value
        })
        .catch((error) => {
          console.log(error.response?.data);
          reject(error); // Reject the Promise with the error
        });
    });
  }
  function retrieveItems() {
    retrieveAllItemsApi()
      .then((response) => {
        setItems(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveVendorOffers() {
    retrieveAllOffersApi("VENDOR")
      .then((response) => {
        setVendorOffers(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }


  function retrieveItemById(id) {
    retrieveItemByIdApi(id)
      .then((response) => {
        setItem(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveSamples() {
    retrieveAllSamplesApi()
      .then((response) => {
        setSamples(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveSampleById(id) {
    retrieveSampleByIdApi(id)
      .then((response) => {
        setSample(response?.data);
        console.log(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveCustomers() {
    retrieveFastStakeholdersApi("CUSTOMER")
      .then((response) => {
        setCustomers(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveCosts() {
    retrieveAllCostsApi()
      .then((response) => {
        setCosts(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveCostById(id) {
    retrieveCostByIdApi(id)
      .then((response) => {
        setCost(response?.data);
        console.log(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveCustomerOffers(target = "rows") {
    retrieveFastOffersApi("CUSTOMER")
      .then((response) => {
         if (target === "rows") {
        setRows(response?.data);
      } else if (target === "offers") {
        setOffers(response?.data);
      }
      })
      .catch((error) => console.log(error.response?.data));
  }

  function getMaxOfferNumber() {
    retrieveMaxOfferNumberApi("CUSTOMER")
      .then((response) => {
        setMaxOfferGroupNumber(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function approveOffer(offerId) {
    approveOfferApi(offerId)
      .then((response) => {
        toast.success("Customer offer approved successfully.");
        if (rows && setRows) {
          const idx = rows.findIndex(row => row.id === offerId);
          
          if (idx !== -1) {
            const newRows = [...rows];
            newRows[idx] = { ...newRows[idx], approvalStatus: "Approved" }; 
            setRows(newRows);
          }
        }
      })
      .catch((error) => {
        toast.error("No Authorization");
        console.log(error.response.data);
      });
  }

  const openBulkAssignDialog = () => {
    if (!selectedData.length) {
      toast.error("Please select at least one offer.");
      return;
    }
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`You can select up to ${MAX_BULK_SELECTION} offers for bulk actions.`);
      return;
    }
    setBulkSelectedUser("");
    setIsBulkAssignDialogOpen(true);
  };

  const closeBulkAssignDialog = () => {
    setBulkSelectedUser("");
    setIsBulkAssignDialogOpen(false);
  };

  const openBulkApproveDialog = () => {
    if (!selectedData.length) {
      toast.error("Please select at least one offer.");
      return;
    }
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`You can select up to ${MAX_BULK_SELECTION} offers for bulk actions.`);
      return;
    }
    setIsBulkApproveDialogOpen(true);
  };

  const closeBulkApproveDialog = () => {
    setIsBulkApproveDialogOpen(false);
  };

  const handleBulkAssignment = async () => {
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`Bulk assignment supports up to ${MAX_BULK_SELECTION} offers at once.`);
      return;
    }

    if (!bulkSelectedUser) {
      toast.error("Please select a user.");
      return;
    }

    const eligibleRows = selectedData.filter((row) => row?.approvalStatus !== "Approved");
    if (!eligibleRows.length) {
      toast.error("Selected offers are already approved and cannot be reassigned.");
      return;
    }

    const assignmentDate = new Date();
    const results = await Promise.allSettled(
      eligibleRows.map(async (row) => {
        const detailsResponse = await retrieveOfferByIdApi(row.id);
        const baseRow = detailsResponse?.data || row;
        const updatedRow = {
          ...baseRow,
          assignedUser: bulkSelectedUser,
          assignedUserId: bulkSelectedUser?.id,
          assignedUserName: bulkSelectedUser?.name,
          assignedUserEmail: bulkSelectedUser?.email,
          assignor: user?.email,
          assignmentDate,
          operation: "ASSIGNMENT",
        };
        return updateOfferApi(updatedRow.id, updatedRow);
      }),
    );

    const successCount = results.filter((result) => result.status === "fulfilled").length;
    const failedCount = results.length - successCount;

    if (successCount > 0) {
      const successIds = new Set(
        eligibleRows
          .filter((_, index) => results[index].status === "fulfilled")
          .map((row) => row.id),
      );
      setRows((prevRows) =>
        prevRows.map((row) =>
          successIds.has(row.id)
            ? {
                ...row,
                assignedUser: bulkSelectedUser,
                assignedUserId: bulkSelectedUser?.id,
                assignedUserName: bulkSelectedUser?.name,
                assignedUserEmail: bulkSelectedUser?.email,
                assignor: user?.email,
                assignmentDate,
                operation: "ASSIGNMENT",
              }
            : row,
        ),
      );
      setSelectedData((prevSelectedData) =>
        prevSelectedData.map((row) =>
          successIds.has(row.id)
            ? {
                ...row,
                assignedUser: bulkSelectedUser,
                assignedUserId: bulkSelectedUser?.id,
                assignedUserName: bulkSelectedUser?.name,
                assignedUserEmail: bulkSelectedUser?.email,
                assignor: user?.email,
                assignmentDate,
                operation: "ASSIGNMENT",
              }
            : row,
        ),
      );
    }

    if (successCount > 0) {
      toast.success(`${successCount} customer offer(s) assigned successfully.`);
    }
    if (failedCount > 0) {
      toast.error(`${failedCount} customer offer(s) could not be assigned.`);
    }

    closeBulkAssignDialog();
  };

  const handleBulkApprove = async () => {
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`Bulk approval supports up to ${MAX_BULK_SELECTION} offers at once.`);
      return;
    }

    const notOwnedRows = selectedData.filter(
      (row) => row?.assignedUserEmail !== user?.email,
    );
    const eligibleRows = selectedData.filter(
      (row) => row?.approvalStatus !== "Approved" && row?.assignedUserEmail === user?.email,
    );

    if (notOwnedRows.length > 0) {
      toast.error(
        `${notOwnedRows.length} selected offer(s) are not assigned to you and were skipped.`,
      );
    }

    if (!eligibleRows.length) {
      toast.error("No selected offer is eligible for approval by you.");
      return;
    }

    const results = await Promise.allSettled(
      eligibleRows.map((row) => approveOfferApi(row.id)),
    );

    const successCount = results.filter((result) => result.status === "fulfilled").length;
    const failedCount = results.length - successCount;

    if (successCount > 0) {
      const successIds = new Set(
        eligibleRows
          .filter((_, index) => results[index].status === "fulfilled")
          .map((row) => row.id),
      );
      setRows((prevRows) =>
        prevRows.map((row) =>
          successIds.has(row.id)
            ? {
                ...row,
                approvalStatus: "Approved",
              }
            : row,
        ),
      );
    }

    if (successCount > 0) {
      toast.success(`${successCount} customer offer(s) approved successfully.`);
    }
    if (failedCount > 0) {
      toast.error(`${failedCount} customer offer(s) could not be approved.`);
    }

    closeBulkApproveDialog();
  };

  const newOfferGroupNumber = maxOfferGroupNumber + 1;

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      setSelectedData(rows);
      return;
    } else {
      setSelected([]);
      setSelectedData([]);
    }
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClick = (event, name, row) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    const selectedDataIndex = selectedData.indexOf(row);
    let newSelectedData = [];

    if (selectedDataIndex === -1) {
      newSelectedData = newSelectedData.concat(selectedData, row);
    } else if (selectedDataIndex === 0) {
      newSelectedData = newSelectedData.concat(selectedData.slice(1));
    } else if (selectedDataIndex === selectedData.length - 1) {
      newSelectedData = newSelectedData.concat(selectedData.slice(0, -1));
    } else if (selectedDataIndex > 0) {
      newSelectedData = newSelectedData.concat(
        selectedData.slice(0, selectedDataIndex),
        selectedData.slice(selectedDataIndex + 1),
      );
    }
    setSelectedData(newSelectedData);

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDuplicate = (row) => {
    const newRow = {
      ...row,
      itemId: row?.item?.id,
      stakeholderId: row?.stakeholder?.id,
      firstSampleId: row?.firstSample?.id,
      secondSampleId: row?.secondSample?.id,
      estimatedCostId: row?.estimatedCost?.id,
      approvalStatus: "Not Approved",
    };
    console.log(row);
    createOfferApi(newRow)
      .then((response) => {
        toast.success("Customer offer duplicated successfully. Please refresh the page.");
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        console.log(error.response.data);
      });
  };

  const handleCreateSample = (offer) => {
    setAddViewStates({
      item: offer?.item,
      itemId: offer?.item?.id,
      salesGrade: offer?.salesGrade,
      salesOrigin: offer?.salesOrigin,
      salesCrop: offer?.salesCrop,
      salesNicotine: offer?.salesNicotine,
      salesSugar: offer?.salesSugar,
    });
    setAddSample(true);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  function formatDate(date) {
    let day = date.getDate().toString().padStart(2, "0");
    let month = (date.getMonth() + 1).toString().padStart(2, "0");
    let year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  var today = new Date();
  var formattedToday = formatDate(today);
  var tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  var formattedTomorrow = formatDate(tomorrow);

  var dayAfter = new Date(today);
  dayAfter.setDate(today.getDate() + 2);
  var formattedDayAfter = formatDate(dayAfter);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const startOfDay = (date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const startOfToday = startOfDay(today);

  const firstRefusalOffers = new Map();
  rows.forEach((row) => {
    if (
      row.status === "First Refusal" &&
      new Date(row.statusDeadline) >= startOfToday
    ) {
      const existingOffers = firstRefusalOffers.get(row?.item?.id) || [];
      existingOffers.push({
        offerId: row?.id,
        volume: row?.volume,
      });
      firstRefusalOffers.set(row?.item?.id, existingOffers);
    }
  });

  const optionedOffers = new Map();
  rows.forEach((row) => {
    if (
      row.status === "Optioned" &&
      new Date(row.statusDeadline) >= startOfToday
    ) {
      const existingOptionedOffers = optionedOffers.get(row?.item?.id) || [];
      existingOptionedOffers.push({
        offerId: row?.id,
        volume: row?.volume,
      });
      optionedOffers.set(row?.item?.id, existingOptionedOffers);
    }
  });

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, rows, editCustomerOffer],
  );

  if (userLoading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <div>Not authorized</div>;
  }

  
  return (
    <div>
      {addView ? (
        <AddCustomerOffer
          setAddView={setAddView}
          rows={rows}
          setRows={setRows}
          locatedData={location?.state?.data}
          prevLocation={location?.state?.prevLocation}
          newOfferGroupNumber={newOfferGroupNumber}
        />
      ) : editCustomerOffer.visible ? (
        <EditCustomerOffer
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editCustomerOffer={editCustomerOffer}
          setEditCustomerOffer={setEditCustomerOffer}
          mapOffer={mapOffer}
        />
      ) : addOfferToGroup.visible ? (
        <AddSingleCustomerOffer
          setAddViewStates={setAddViewStates}
          addViewStates={addViewStates}
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          addOfferToGroup={addOfferToGroup}
          setAddOfferToGroup={setAddOfferToGroup}
        />
      ) : showOrderPopup.visible ? (
        <CreateOrder
          rows={rows}
          setRows={setRows}
          setCreateOrder={setShowOrderPopup}
          createOrder={showOrderPopup}
          mapOffer={mapOffer}
        />
      ) : pdfPopup.visible ? (
        <CreateOfferPdf setPdfPopup={setPdfPopup} pdfPopup={pdfPopup} />
      ) : showOfferPopup.visible ? (
        <CreateVendorOffer
          setCreateVendorOffer={setShowOfferPopup}
          createVendorOffer={showOfferPopup}
        />
      ) : editItem.visible ? (
        <EditItem
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editItem={editItem}
          setEditItem={setEditItem}
        />
      ) : editVendorOffer.visible ? (
        <EditVendorOffer
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editVendorOffer={editVendorOffer}
          setEditVendorOffer={setEditVendorOffer}
        />
      ) : editCost.visible ? (
        <EditCost
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editCost={editCost}
          setEditCost={setEditCost}
        />
      ) : editSample.visible ? (
        <EditSample
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editSample={editSample}
          setEditSample={setEditSample}
        />
      ) : addSample ? (
        <AddSample
          addViewStates={addViewStates}
          setAddViewStates={setAddViewStates}
          rows={rows}
          setRows={setRows}
          setAddView={setAddSample}
        />
      ) : (
        <>
          {showFilters && (
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <CustomerOfferSearch
                setFilterCustomerOffer={setFilterCustomerOffer}
                filterCustomerOffer={filterCustomerOffer}
                retrieveItems={retrieveItems}
                items={items}
                retrieveVendorOffers={retrieveVendorOffers}
                referenceVendorOffers={vendorOffers}
                retrieveCustomers={retrieveCustomers}
                retrieveSamples={retrieveSamples}
                samples={samples}
                customers={customers}
                retrieveCosts={retrieveCosts}
                costs={costs}
                retrieveCustomerOffers={retrieveCustomerOffers}
                offers={offers}
              />
              <Grid
                container
                spacing={2}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="contained"
                    fullWidth
                    size="small"
                    onClick={() => {
                      retrieveFastFilteredOffersApi(filterCustomerOffer)
                        .then((response) => {
                          setRows(response?.data);
                        })
                        .catch((error) => {
                          console.log(error?.response?.data);
                        });
                    }}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="outlined"
                    fullWidth
                    size="small"
                    onClick={() => {
                      setFilterCustomerOffer({
                        id: 0,
                        offerYear: "",
                        offerType: "CUSTOMER",
                        stakeHolderType: "CUSTOMER",
                        itemBuyingGrade: "",
                        itemIdList: [],
                        stakeholderIdList: [],
                        costIdList: [],
                        companyList: [],
                        approvalStatusList: [],
                        statusList: [],
                        statusDeadline: "",
                        statusDeadlineFrom: "",
                        statusDeadlineTo: "",
                        firstSampleDate: "",
                        secondSampleDate: "",
                        firstSampleIdList: [],
                        firstSampleStatusList: [],
                        secondSampleIdList: [],
                        secondSampleStatusList: [],
                        paymentTerm: "",
                        paymentTermList: [],
                        salesOrigin: "",
                        salesOriginList: [],
                        salesCrop: null,
                        salesNicotine: null,
                        salesSugar: null,
                        incotermList: [],
                        offerDate: "",
                        offerDateFrom: "",
                        offerDateTo: "",
                        validityDate: "",
                        validityDateFrom: "",
                        validityDateTo: "",
                        validityDatePassed: "",
                        volumeUnitList: [],
                        firstPriceCurrencyList: [],
                        finalPriceCurrencyList: [],
                        remark: "",
                        portOfLoading: "",
                        portOfLoadingList: [],
                        portOfDischargeList: [],
                        comment: "",
                        documentStatusList: [],
                        tobaccoCode: "",
                        salesGrade: "",
                        buyingGrade: "",
                        customerGrade: "",
                        internalGrade: "",
                        originList: [],
                        typeList: [],
                        leafFormList: [],
                        colorList: [],
                        storageList: [],
                        itemStorage: "",
                        crop: null,
                        cropFrom: null,
                        cropTo: null,
                        nicotineFrom: null,
                        nicotineTo: null,
                        sugarFrom: null,
                        sugarTo: null,
                        nicotine: null,
                        sugar: null,
                        moisture: null,
                        firstOfferPrice: null,
                        firstOfferPriceFrom: null,
                        firstOfferPriceTo: null,
                        finalOfferPrice: null,
                        finalOfferPriceFrom: null,
                        finalOfferPriceTo: null,
                        numberOfCases: null,
                        numberOfCasesFrom: null,
                        numberOfCasesTo: null,
                        netWeightPerCase: null,
                        netWeightPerCaseFrom: null,
                        netWeightPerCaseTo: null,
                        volume: null,
                        volumeFrom: null,
                        volumeTo: null,
                        totalAmount: null,
                        totalAmountFrom: null,
                        totalAmountTo: null,
                        offerGroupNumber: null,
                        orderGroupNumber: null,
                        referenceVendorOfferIdList: [],
                        recordStatusList: ["ACTIVE"],
                        idList: [],
                      });
                    }}
                  >
                    Clear Filters
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}

          <Box sx={{ width: "100%", mt: 2 }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <EnhancedTableToolbar
                numSelected={selected.length}
                showFilters={showFilters}
                setShowFilters={setShowFilters}
                rows={rows}
                setAddView={setAddView}
                selected={selected}
                setPdfPopup={setPdfPopup}
                pdfPopup={pdfPopup}
                selectedData={selectedData}
                onOpenBulkAssignDialog={openBulkAssignDialog}
                onOpenBulkApproveDialog={openBulkApproveDialog}
              />
              <Dialog open={isBulkAssignDialogOpen} onClose={closeBulkAssignDialog} maxWidth="md" fullWidth>
                <DialogTitle>Assign Selected Customer Offers</DialogTitle>
                <DialogContent>
                  <Typography sx={{ mb: 1 }}>
                    You are assigning {selectedData.length} offer(s). Review details below before confirming.
                  </Typography>
                  <Select
                    fullWidth
                    size="small"
                    value={bulkSelectedUser}
                    onChange={(e) => setBulkSelectedUser(e.target.value)}
                    sx={{ mb: 2 }}
                  >
                    <MenuItem value="">Select a User</MenuItem>
                    {users.map((option) => (
                      <MenuItem key={option.id} value={option}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Offer Number</TableCell>
                        <TableCell>Customer</TableCell>
                        <TableCell>Item</TableCell>
                        <TableCell>Current Assignee</TableCell>
                        <TableCell>Approval</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedData.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell>{row.id}</TableCell>
                          <TableCell>{(row?.offerYear ? `${row.offerYear}-` : "") + (row?.offerGroupNumber || "")}</TableCell>
                          <TableCell>{row?.stakeholderName || "-"}</TableCell>
                          <TableCell>{row?.itemBuyingGrade || row?.itemTobaccoCode || "-"}</TableCell>
                          <TableCell>{row?.assignedUserName || "Unassigned"}</TableCell>
                          <TableCell>{row?.approvalStatus || "N/A"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </DialogContent>
                <DialogActions>
                  <Button onClick={closeBulkAssignDialog}>Cancel</Button>
                  <Button onClick={handleBulkAssignment} disabled={!bulkSelectedUser}>Assign</Button>
                </DialogActions>
              </Dialog>
              <Dialog open={isBulkApproveDialogOpen} onClose={closeBulkApproveDialog} maxWidth="md" fullWidth>
                <DialogTitle>Approve Selected Customer Offers</DialogTitle>
                <DialogContent>
                  <Typography sx={{ mb: 2 }}>
                    You are approving {selectedData.length} offer(s). Review details below before confirming.
                  </Typography>
                  <TableContainer component={Paper}
                    sx={{
                      border: "2px solid #d1dfe8",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}>
                  <Table size="small" sx={{ tableLayout: "fixed", width: "100%" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Offer ID</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Customer</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Buying Grade</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Origin</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Crop</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Volume</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Assigned To</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Approval</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedData.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.id || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.stakeholderName || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.itemBuyingGrade || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.itemOrigin || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.itemCrop || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.volume || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.assignedUserName || "Unassigned"} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.approvalStatus || "N/A"} /></TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  </TableContainer>
                </DialogContent>
                <DialogActions>
                  <Button onClick={closeBulkApproveDialog}>Cancel</Button>
                  <Button onClick={handleBulkApprove}>Approve</Button>
                </DialogActions>
              </Dialog>
              <TableContainer style={{ maxHeight: 700 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  sx={{
                    minWidth: 750,
                    "& .MuiTableCell-root": {
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                    },
                    "& .MuiTableCell-head": {
                      backgroundColor: "#20315d",
                      color: "white",
                      borderRight: "1px solid rgba(49, 64, 128, 1)",
                    },
                  }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  style={{ width: "max-content" }}
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                    showButtons={showButtons}
                  />

                  <TableBody>
                    {visibleRows.map((row, index) => {
                      const isItemSelected = isSelected(row?.id);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          style={
                            isSelected(row.id) ? {
                              background: "#d7e7fc",
                              textDecoration: new Date(row?.validityDate) < today && row?.validityDate != null
                                ? "line-through"
                                : new Date(row?.statusDeadline) < today && row?.statusDeadline != null
                                  ? "line-through"
                                  : "none"
                            }
                              : new Date(row?.validityDate) < today && row?.validityDate != null
                                ? { textDecoration: "line-through", background: "white" }
                                : new Date(row?.statusDeadline) < today && row?.statusDeadline != null
                                  ? { textDecoration: "line-through", background: "white" }
                                  : row?.status === "Confirmed"
                                    ? { background: "#c8e6c9" }
                                    : new Date(row?.statusDeadline).toDateString() === today.toDateString()
                                      ? { background: "#f22e2e" }
                                      : new Date(row?.statusDeadline).toDateString() === tomorrow.toDateString()
                                        ? { background: "#f76f6f " }
                                        : new Date(row?.statusDeadline).toDateString() === dayAfter.toDateString()
                                          ? { background: "#f5d3d3 " }
                                          : index % 2
                                            ? { background: "#f0f0f0" }
                                            : { background: "white" }
                          }
                          hover
                          onClick={(event) => handleClick(event, row?.id, row)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row?.id}
                          selected={isItemSelected}
                          sx={{ cursor: "pointer" }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                          </TableCell>
                          <TableCell padding="normal"
                            sx={{
                              position: "sticky",
                              left: 0,
                              background: "inherit",
                              zIndex: 2,
                              display: "flex", alignItems: "center"
                            }}>
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowButtons(!showButtons);
                              }}
                            >
                              <ArrowForwardIosIcon
                                style={{
                                  transform: showButtons
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                }}
                              />
                            </IconButton>
                            {showButtons && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  marginLeft: "10px",
                                }}
                              >
                                <ApprovedEditButton
                                  row={row}
                                  isApproved={row?.approvalStatus === "Approved"}
                                  disabled={row?.recordStatus === "PASSIVE"}
                                  onEdit={async () => {
                                    if (!row?.id) { alert("Please refresh the page."); return; }
                                    setLock({ ...lock, recordId: row.id });
                                    try {
                                      const updatedLock = {
                                        ...lock,
                                        recordId: row.id,
                                      };
                                      const isLocked = await acquireLock(
                                        updatedLock,
                                      );
                                      if (isLocked) {
                                        retrieveOfferByIdApi(row?.id)
                                          .then((response) => {
                                            setOfferData(response?.data);
                                            setEditCustomerOffer({
                                              visible: true,
                                              data: response?.data,
                                              index: index,
                                            });
                                          })
                                          .catch((error) => {
                                            window.alert("Failed to retrieve offer. Please try again later.");
                                          });
                                      } else {
                                        toast.error(
                                          "It seems another user is currently editing this record. Please try again later or close any open windows.",
                                        );
                                      }
                                    } catch (error) {
                                      console.error("Error acquiring lock:", error);
                                      // Handle the error if needed
                                    }
                                  }}
                                />
                                {/*<Button
                                  onClick={async (e) => {
                                    if (!row?.id) {
                                      alert("Please refresh the page.");
                                      return;
                                    }
                                    setLock({ ...lock, recordId: row.id });
                                    try {
                                      const updatedLock = {
                                        ...lock,
                                        recordId: row.id,
                                      };
                                      const isLocked = await acquireLock(
                                        updatedLock,
                                      );
                                      console.log("islocked:", isLocked);

                                      if (isLocked) {
                                        retrieveOfferByIdApi(row?.id)
                                        .then((response) => {
                                          setOfferData(response?.data);
                                          setEditCustomerOffer({
                                            visible: true,
                                            data: response?.data,
                                            index: index,
                                          });
                                        })
                                        .catch((error) => {
                                          window.alert("Failed to retrieve offer. Please try again later.");
                                        });
                                        e.preventDefault();
                                      } else {
                                        toast.error(
                                          "It seems another user is currently editing this record. Please try again later or close any open windows.",
                                        );
                                      }
                                    } catch (error) {
                                      console.error("Error acquiring lock:", error);
                                      // Handle the error if needed
                                    }
                                  }}
                                >
                                  Edit
                                </Button>*/}

                                <Tooltip title="Approve Offer">
                                  <ApproveOfferButton
                                    row={row}
                                    approveOffer={approveOffer}>
                                  </ApproveOfferButton>
                                </Tooltip>
                                <Tooltip title="Decline Offer">
                                  <IconButton
                                    color="secondary"
                                    disabled={
                                      row?.approvalStatus === "Declined" ||
                                      row?.recordStatus === "PASSIVE" ||
                                      !row?.assignedUserId
                                    }
                                    onClick={() => {
                                      if (
                                        user?.email ===
                                        row?.assignedUserEmail
                                      ) {
                                        retrieveOfferByIdApi(row?.id)
                                        .then((response) => {
                                          setOfferData(response?.data);
                                          openDeclineDialog(response?.data);
                                        })
                                        .catch((error) => {
                                          window.alert("Failed to retrieve offer. Please try again later.");
                                         });
                                      } else {
                                        toast.error(
                                          "This offer is not assigned to you.",
                                        );
                                      }
                                    }}
                                  >
                                    <CancelIcon />
                                  </IconButton>
                                </Tooltip>
                                <Dialog
                                  open={isDeclineDialogOpen}
                                  onClose={closeDeclineDialog}
                                >
                                  <DialogTitle>Decline Offer</DialogTitle>
                                  <DialogContent>
                                    <Typography variant="body2">
                                      Decline Note
                                    </Typography>
                                    <TextField
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      value={declineNote}
                                      onChange={(e) =>
                                        (declineNote = e.target.value)
                                      }
                                    />
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={closeDeclineDialog}>
                                      Cancel
                                    </Button>
                                    <Button onClick={handleDecline}>
                                      Save
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                                <Button
                                  variant="outlined"
                                  disabled={
                                    row?.recordStatus === "PASSIVE"
                                  }
                                  onClick={(e) => {
                                    if (!row?.id) {
                                      alert("Please refresh the page.");
                                      return;
                                    }
                                     retrieveOfferByIdApi(row?.id)
                                        .then((response) => {
                                          setOfferData(response?.data);
                                          openAssignUserDialog(response?.data);
                                        })
                                        .catch((error) => {
                                          window.alert("Failed to retrieve offer. Please try again later.");
                                        });
                                  }}
                                >
                                  Assign
                                </Button>

                                <Dialog
                                  open={isAssignUserDialogOpen}
                                  onClose={closeAssignUserDialog}
                                >
                                  <DialogTitle>
                                    Assign Offer to a User
                                  </DialogTitle>
                                  <DialogContent>
                                    <Select
                                      value={selectedUser}
                                      onChange={(e) =>
                                        setSelectedUser(e.target.value)
                                      }
                                      displayEmpty
                                      fullWidth
                                    >
                                      <MenuItem value="" disabled>
                                        {selectedRow?.assignedUserName
                                          ? selectedRow?.assignedUserName
                                          : "Select a User"}
                                      </MenuItem>
                                      {users.map((user) => (
                                        <MenuItem key={user} value={user}>
                                          {user.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={closeAssignUserDialog}>
                                      Cancel
                                    </Button>
                                    <Button
                                      onClick={handleAssignment}
                                      disabled={!selectedUser}
                                    >
                                      Save
                                    </Button>
                                  </DialogActions>
                                </Dialog>

<Button
  variant="outlined"
  disabled={row?.approvalStatus !== "Approved" ||
       row?.recordStatus === "PASSIVE" ||
       ((row?.statusDeadline
         ? format(
             new Date(row?.statusDeadline),
             "dd/MM/yyyy",
           )
         : "") < formattedToday &&
         row?.statusDeadline != null)}
  onClick={() => {
     if (!row?.id) {
             alert("Please refresh the page.");
             return;
           }
 setReservationDialog({ open: true, offer: row });
    setReservationData({
      company: row?.company || "",
      reservationDate: todayStr,
      validityDate: todayStr,
      numberOfCases: "",
      netWeightPerCase: "",
      quantity: "",
      volumeUnit: "KG",
      remark: "",
    });
  }}
>
  Reserve
</Button>
 <ReservationDialog
        open={reservationDialog?.open}
        offer={reservationDialog?.offer}
        onClose={() => setReservationDialog({ open: false, offer: null })}
        onSave={data => {
    // Build the full payload
    const payload = {
      offerId: reservationDialog?.offer?.id,
      reservationType: data?.reservationType,
      company: data?.company,
      reservationDate: data?.reservationDate,
      validityDate: data?.validityDate,
      numberOfCases: parseFloat(data?.numberOfCases),
      netWeightPerCase: parseFloat(data?.netWeightPerCase),
      quantity: parseFloat(data?.quantity),
      volumeUnit: data?.volumeUnit,
      remark: data?.remark,
    };

    createReservationApi(payload)
      .then(() => {
        toast.success("Reserved successfully!");
        // close the dialog
        setReservationDialog({ open: false, offer: null });
        // optionally refresh your rows or update state here…
      })
      .catch(err => {
        console.error(err);
        toast.error("Reservation failed.");
      });
  }}
      />

                                <Button
                                  style={{ whiteSpace: "nowrap" }}
                                  variant="outlined"
                                  disabled={
                                    row?.approvalStatus !== "Approved" ||
                                    ((row?.statusDeadline
                                      ? format(
                                        new Date(row?.statusDeadline),
                                        "dd/MM/yyyy",
                                      )
                                      : "") < formattedToday &&
                                      rows?.statusDeadline != null)
                                  }
                                  onClick={() => {
                                    if (!row?.id) {
                                      alert("Please refresh the page.");
                                      return;
                                    }
                                    const offerDetails = firstRefusalOffers.get(
                                      row.itemId,
                                    );
                                    const optionedOfferDetails = optionedOffers.get(
                                      row.itemId,
                                    );

                                    if (
                                      offerDetails &&
                                      offerDetails.length > 0 &&
                                      row.status !== "First Refusal"
                                    ) {
                                      const offerDetailsMessage = offerDetails
                                        .map(
                                          (offer, index) =>
                                            `Offer ${index + 1}: ID: ${offer.id
                                            } Volume: ${offer.volume} KG`,
                                        )
                                        .join("\n");

                                      const confirmMessage = `Selected item's offers with "First Refusal" status: \n\n${offerDetailsMessage}\n\nDo you want to continue?`;

                                      if (!window.confirm(confirmMessage)) {
                                        return;
                                      }
                                    }

                                    if (
                                      optionedOfferDetails &&
                                      optionedOfferDetails.length > 0 &&
                                      row.status !== "Optioned"
                                    ) {
                                      const offerDetailsMessage =
                                        optionedOfferDetails
                                          .map(
                                            (offer, index) =>
                                              `Offer ${index + 1}: ID: ${offer.id
                                              } Volume: ${offer.volume} KG`,
                                          )
                                          .join("\n");

                                      const confirmMessage = `Selected item's offers with "Optioned" status: \n\n${offerDetailsMessage}\n\nDo you want to continue?`;

                                      if (!window.confirm(confirmMessage)) {
                                        return;
                                      }
                                    }
                                     retrieveOfferByIdApi(row?.id)
                                       .then((response) => {
                                         setShowOrderPopup({
                                           data: response?.data,
                                           visible: true,
                                         })
                                       })
                                       .catch((error) => {
                                         window.alert("Failed to retrieve offer. Please try again later.");
                                       });
                                  }}
                                >
                                  Create SO
                                </Button>
                                <Button variant="outlined" size="small"  onClick={() => {
                                        if (!row?.id) {
                                         alert("Please refresh the page.");
                                         return;
                                       }
                                     retrieveOfferByIdApi(row?.id)
                                     .then((response) => {
                                      handleCreateSample(response?.data)
                                     })
                                     .catch((error) => {
                                       window.alert("Failed to retrieve offer. Please try again later.");
                                     });
                                     }}>
                                  Create Sample
                                </Button>
                                <Button
                                  variant="outlined"
                                 onClick={() => {
                                   if (!row?.id) {
                                     alert("Please refresh the page.");
                                     return;
                                   }
                                   retrieveOfferByIdApi(row?.id)
                                   .then((response) => {
                                     handleDuplicate(response?.data)
                                   })
                                   .catch((error) => {
                                     window.alert("Failed to retrieve offer. Please try again later.");
                                   });}
                                 }
                                >
                                  Duplicate
                                </Button>
                                <Button
                                  variant="outlined"
                                  onClick={(e) => {
                                    if (!row?.id) {
                                      alert("Please refresh the page.");
                                      return;
                                    }
                                     retrieveOfferByIdApi(row?.id)
                                       .then((response) => {
                                         setAddOfferToGroup({
                                           visible: true,
                                           data: response?.data,
                                           index: index,
                                         });
                                       })
                                       .catch((error) => {
                                         window.alert("Failed to retrieve offer. Please try again later.");
                                       });
                                    e.preventDefault();
                                  }}
                                >
                                  Add New Offer To The Group
                                </Button>
                              </div>
                            )}
                          </TableCell>
                          <TableCell align="center" sx={{
                            position: "sticky",
                            left: showButtons ? 60 + 650 : 60,
                            background: "inherit",
                            zIndex: 1,
                          }}>{row?.id}</TableCell>
                          <TableCell align="center" sx={{
                            position: "sticky",
                            left: showButtons ? 125 + 650 : 125,
                            background: "inherit",
                            zIndex: 1,
                          }}>
                            {row?.offerYear}
                            {row?.offerYear && row?.offerGroupNumber && "-"}
                            {row?.offerGroupNumber}
                          </TableCell>
                          <TableCell align="center">
                            {row?.assignedUserName}
                          </TableCell>
                          <TableCell align="center">
                            {row?.stakeholderCode}
                          </TableCell>
                          <TableCell align="center" sx={{
                            position: "sticky",
                            left: showButtons ? 268 + 650 : 268,
                            background: "inherit",
                            zIndex: 1,
                          }}>
                            {row?.stakeholderName}
                          </TableCell>
                          <TableCell align="center">
                            <ItemButton
                              row={row}
                              setEditItem={setEditItem}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {row?.itemTobaccoCode}
                          </TableCell>
                          <TableCell align="center" sx={{
                            position: "sticky",
                            left: showButtons ? 439 + 650 : 439,
                            background: "inherit",
                            zIndex: 1,
                          }}>
                            {row?.itemBuyingGrade}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesGrade}
                          </TableCell>
                          <TableCell align="center">
                            {row?.itemCrop}
                          </TableCell>
                          <TableCell align="center">{row?.salesCrop}</TableCell>
                          <TableCell align="center">
                            {row?.itemNicotine}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesNicotine}
                          </TableCell>
                          <TableCell align="center">
                            {row?.itemSugar}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesSugar}
                          </TableCell>
                          <TableCell align="center">
                            {row?.itemMoisture}
                          </TableCell>
                          <TableCell align="center">
                            {row?.itemOrigin}
                          </TableCell>
                          <TableCell align="center">
                            {row?.salesOrigin}
                          </TableCell>
                          <TableCell align="center">
                            {row?.itemType}
                          </TableCell>
                          <TableCell align="center">
                            {row?.itemStorage}
                          </TableCell>
                          <TableCell align="center">{row?.company}</TableCell>
                          <TableCell align="center">
                            {row?.approvalStatus}
                            {row?.approvalStatus === "Declined" &&
                              (row?.declineNote ? "-" + row?.declineNote : "")}
                          </TableCell>
                          <TableCell align="center">{row?.status}</TableCell>
                          <TableCell align="center">
                            {row?.statusDeadline
                              ? format(
                                new Date(row?.statusDeadline),
                                "dd/MM/yyyy",
                              )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            <CostButton
                              row={row}
                              setEditCost={setEditCost}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {row?.estimatedTotalCost}
                          </TableCell>
                          <TableCell align="center">
                            {row?.buyingPrice &&
                              (row?.buyingPrice +
                                " " +
                                row?.buyingPriceCurrency ||
                                "")}
                          </TableCell>
                          <TableCell align="center">
                            {row?.firstOfferPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                              }).format(row.firstOfferPrice)}`
                              : ""}{" "}
                            {row?.firstOfferPriceCurrency}
                          </TableCell>
                          <TableCell align="center">
                            {row?.usdFirstOfferPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                              }).format(row.usdFirstOfferPrice)} USD`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center">
                            {row?.finalOfferPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                              }).format(row.finalOfferPrice)}`
                              : ""}{" "}
                            {row?.finalOfferPriceCurrency}
                          </TableCell>
                          <TableCell align="center">
                            {row?.usdFinalOfferPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                              }).format(row.usdFinalOfferPrice)} USD`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center">
                            <SampleButton
                              row={row}
                              id={row?.firstSampleId}
                              setEditSample={setEditSample}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {row?.firstSampleDeliveryDate
                              ? format(
                                new Date(row?.firstSampleDeliveryDate),
                                "dd/MM/yyyy",
                              )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.firstSampleStatus}
                          </TableCell>
                          <TableCell align="center">
                            <SampleButton
                              row={row}
                              id={row?.secondSampleId}
                              setEditSample={setEditSample}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {row?.secondSampleDeliveryDate
                              ? format(
                                new Date(row?.secondSampleDeliveryDate),
                                "dd/MM/yyyy",
                              )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.secondSampleStatus}
                          </TableCell>
                          <TableCell align="center">{row?.packaging}</TableCell>
                          <TableCell
                            align="center"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {row?.paymentTerm}
                          </TableCell>
                          <TableCell align="center">{row?.incoterm}</TableCell>
                          <TableCell align="center">
                            {row?.numberOfCases}
                          </TableCell>
                          <TableCell align="center">
                            {row?.netWeightPerCase}
                          </TableCell>
                          <TableCell align="center">
                            {row?.volume
                              ? `${new Intl.NumberFormat("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                              }).format(row.volume)}`
                              : ""}{" "}
                            {row?.volumeUnit}
                          </TableCell>
                          <TableCell align="center">
                            {row?.totalAmount
                              ? `${new Intl.NumberFormat("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                              }).format(row.totalAmount)}`
                              : ""}{" "}
                            {row?.finalOfferPriceCurrency}
                          </TableCell>
                          <TableCell align="center">
                            {row?.usdTotalAmount
                              ? `${new Intl.NumberFormat("en-US", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                              }).format(row.usdTotalAmount)}`
                              : ""}{" "}
                            USD
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerDate
                              ? format(new Date(row?.offerDate), "dd/MM/yyyy")
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.validityDate
                              ? format(
                                new Date(row?.validityDate),
                                "dd/MM/yyyy",
                              )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.portOfDischarge}
                          </TableCell>
                          <TableCell align="center">
                            {row?.portOfLoading}
                          </TableCell>
                          <TableCell align="center">{row?.remark}</TableCell>
                          <TableCell align="center">{row?.comment}</TableCell>
                          <TableCell align="center">
                            <a
                              href={row?.offerLink}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {row?.offerLink && (
                                <Button
                                  disableElevation
                                  variant="outlined"
                                  size="small"
                                >
                                  Offer Link
                                </Button>
                              )}
                            </a>
                          </TableCell>
                          <TableCell align="center">
                            {row?.documentStatus}
                          </TableCell>
                          <TableCell align="center">{row?.timestamp ? format(new Date(row.timestamp), 'dd/MM/yyyy HH:mm') : ''}</TableCell>
                          <TableCell align="center">{row?.creator}</TableCell>
                          <TableCell align="center">
                            {row?.recordStatus}
                          </TableCell>
                          <TableCell align="center">
                            <OfferButton
                              row={row}
                              setEditOffer={setEditVendorOffer}
                            />
                          </TableCell>

                          {/* <TableCell padding="normal">
                            <Button
                              style={{
                                whiteSpace: "nowrap",
                              }}
                              variant="outlined"
                              onClick={() =>
                                setShowOfferPopup({
                                  data: row,
                                  visible: true,
                                })
                              }
                            >
                              Create Vendor Offer
                            </Button>

                            </TableCell> */}
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <div style={{
                position: "sticky",
                top: 0,
                background: "white",
                padding: "10px",
                fontWeight: "bold",
                borderBottom: "1px solid #ddd",
                zIndex: 10,
                display: "flex",
                gap: "20px"
              }}>
                <span>Total Volume: {new Intl.NumberFormat("en-US", {
                  style: "decimal",
                  minimumFractionDigits: 2
                }).format(totalVolume)} {rows.length > 0 ? rows[0]?.volumeUnit : ""}</span>

                <span>Total Amount: {new Intl.NumberFormat("en-US", {
                  style: "decimal",
                  minimumFractionDigits: 2
                }).format(usdTotalAmount)} {rows.length > 0 ? "USD" : ""}</span>
              </div>
              <div style={{ marginTop: '20px', marginLeft: '20px' }}>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span
                      style={{
                        background: "#c8e6c9",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: '8px',
                        display: 'inline-block',
                      }}
                    >
                      Confirmed
                    </span>
                    <span>- Confirmed status</span>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span
                      style={{
                        background: "#f22e2e",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: '8px', // Rounded corners
                        display: 'inline-block',
                      }}
                    >
                      Due Today
                    </span>
                    <span>- Status deadline today</span>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span
                      style={{
                        background: "#f76f6f",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: '8px', // Rounded corners
                        display: 'inline-block',
                      }}
                    >
                      Due Tomorrow
                    </span>
                    <span>- Status deadline tomorrow</span>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span
                      style={{
                        background: "#f5d3d3",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: '8px', // Rounded corners
                        display: 'inline-block',
                      }}
                    >
                      Due Day After Tomorrow
                    </span>
                    <span>- Status deadline day after tomorrow</span>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span
                      style={{
                        textDecoration: "line-through",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: '8px', // Rounded corners
                        display: 'inline-block',
                      }}
                    >
                      Expired
                    </span>
                    <span>- Expired status deadline or validity date</span>
                  </div>
                </div>
              </div>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Dense padding"
            />
          </Box>
        </>
      )}
    </div>
  );
}
